<template>
  <b-row class="asc__insertPage">
    <CustomerTargetExcelModal @success="successExcelImportCustomerTarget"></CustomerTargetExcelModal>
    <b-col cols="12">
      <header>
        <b-row>
          <b-col cols="12" md="8">
            <Breadcrumb />
          </b-col>
          <b-col cols="12" md="4" class="text-right">
            <router-link :to="{name: 'CustomerTarget' }">
              <CancelButton />
            </router-link>
            <AddButton @click.native="save()" />
          </b-col>
        </b-row>
      </header>
    </b-col>
    <b-col cols="12" class="asc__insertPage-content-head">
      <section>
        <b-row>
          <NextFormGroup item-key="Code" :error="$v.form.Code">
            <NextInput v-model="form.Code" type="text" :disabled="insertReadonly.Code" />
          </NextFormGroup>
          <NextFormGroup item-key="ErpCode" :error="$v.form.ErpCode">
            <NextInput v-model="form.ErpCode" type="text" :disabled="insertReadonly.ErpCode" />
          </NextFormGroup>
          <NextFormGroup item-key="Description1" :error="$v.form.Description1">
            <NextInput v-model="form.Description1" type="text" :disabled="insertReadonly.Description1" />
          </NextFormGroup>
          <NextFormGroup item-key="TciBreak1Id" :error="$v.form.TciBreak1Id">
            <NextDropdown :disabled="insertReadonly.TciBreak1Id" @input="selectedType('TciBreak1Id', $event)" lookup-key="TCI_BREAKDOWN"/>
          </NextFormGroup>
          <NextFormGroup item-key="ItemColumnName" :error="$v.form.ItemColumnName">
            <NextDropdown
              :disabled="insertReadonly.ItemColumnName"
              v-model="itemColumnName"
              :source="itemCriterias"
              :dynamic-request="{paramId: 'ITEM_CRITERIA'}" label="Label"
              @input="selectColumnName($event)"/>
          </NextFormGroup>
          <NextFormGroup item-key="ItemColumnValue" :error="$v.form.ItemColumnValue">
            <NextDropdown v-model="itemColumnValue"
              :disabled="insertReadonly.ItemColumnValue"
              :source="fieldValues" label="Label"
              @input="selectedType('ItemColumnValue', $event)"
            />
          </NextFormGroup>
          <NextFormGroup item-key="StatusId" :error="$v.form.StatusId">
            <NextCheckBox v-model="form.StatusId" type="number" :disabled="insertReadonly.StatusId" toggle />
          </NextFormGroup>
        </b-row>
      </section>
    </b-col>
    <b-col cols="12">
      <b-tabs>
        <b-tab :title="$t('insert.CustomerTarget.CustomerTargetDetails')">
          <b-row>
            <NextFormGroup :title="$t('insert.CustomerTarget.CustomerId')" :error="$v.customerTargetDetails.customer" :required="true" md="3" lg="3">
              <NextDropdown
                v-model="customerTargetDetails.customer"
                url="VisionNextCustomer/api/Customer/AutoCompleteSearch"
                orConditionFields="Code,Description1"
                :dynamic-and-condition="{ StatusIds: [1]}"
                label="Description1"
                :searchable="true"
                :custom-option="true"
                :is-customer="true"

                />
            </NextFormGroup>
            <NextFormGroup :title="$t('insert.CustomerTarget.TargetQuantity')" :error="$v.customerTargetDetails.targetQuantity" :required="true" md="3" lg="3">
              <NextInput
                v-model="customerTargetDetails.targetQuantity"
                type="number"/>
            </NextFormGroup>
            <NextFormGroup :title="$t('insert.CustomerTarget.TargetUnitId')" :error="$v.customerTargetDetails.targetUnit" md="3" lg="3">
              <NextDropdown :disabled="true" :source="lookupValues" label="Label" v-model="customerTargetDetails.targetUnit" />
            </NextFormGroup>
            <NextFormGroup :title="$t('insert.CustomerTarget.ReqItemId')" :error="$v.customerTargetDetails.reqItem" :required="!(customerTargetDetails.customer && customerTargetDetails.targetQuantity && customerTargetDetails.gainAmount)" md="3" lg="3">
              <NextDropdown v-model="customerTargetDetails.reqItem" :dynamic-and-condition="{ StatusIds: [1] }" url="/VisionNextItem/api/Item/AutocompleteSearch" :searchable="true" :source="items" orConditionFields="Code,Description1" :custom-option="true"/>
            </NextFormGroup>
            <NextFormGroup :title="$t('insert.CustomerTarget.ReqItemQuantity')" :error="$v.customerTargetDetails.reqItemQuantity" :required="!(customerTargetDetails.customer && customerTargetDetails.targetQuantity && customerTargetDetails.gainAmount)" md="3" lg="3">
              <NextInput type="number" v-model="customerTargetDetails.reqItemQuantity"/>
            </NextFormGroup>
            <NextFormGroup :title="$t('insert.CustomerTarget.DescriptionReqItem')" md="3" lg="3">
              <NextInput type="text" v-model="customerTargetDetails.descriptionReqItem"/>
            </NextFormGroup>
            <NextFormGroup :title="$t('insert.CustomerTarget.GainAmount')" :error="$v.customerTargetDetails.gainAmount" :required="true"  md="3" lg="3">
              <NextInput type="number" v-model="customerTargetDetails.gainAmount"/>
            </NextFormGroup>
            <NextFormGroup :title="$t('insert.CustomerTarget.currencyId')" :error="$v.customerTargetDetails.currency" :required="!(customerTargetDetails.customer && customerTargetDetails.targetQuantity && customerTargetDetails.gainAmount)" md="3" lg="3">
              <NextDropdown :disabled="true" v-model="customerTargetDetails.currency" :source="currencies" />
            </NextFormGroup>
            <b-col cols="12" md="2">
              <b-form-group>
                 <AddDetailButton @click.native="addContractItems" />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="2">
              <b-form-group>
                <b-button class="mt-4" size="sm" variant="success" v-b-modal.customer-target-excel-modal><i class="fas fa-file-pdf"/> {{$t('insert.creditBudget.uploadExcel')}}</b-button>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-table-simple bordered small>
              <b-thead>
                <b-th><span>{{$t('insert.CustomerTarget.CustomerId')}}</span></b-th>
                <b-th><span>{{$t('insert.CustomerTarget.TargetQuantity')}}</span></b-th>
                <b-th><span>{{$t('insert.CustomerTarget.TargetUnitId')}}</span></b-th>
                <b-th><span>{{$t('insert.CustomerTarget.ReqItemId')}}</span></b-th>
                <b-th><span>{{$t('insert.CustomerTarget.ReqItemQuantity')}}</span></b-th>
                <b-th><span>{{$t('insert.CustomerTarget.DescriptionReqItem')}}</span></b-th>
                <b-th><span>{{$t('insert.CustomerTarget.GainAmount')}}</span></b-th>
                <b-th><span>{{$t('insert.CustomerTarget.currencyId')}}</span></b-th>
                <b-th><span>{{$t('list.operations')}}</span></b-th>
              </b-thead>
              <b-tbody>
                <b-tr v-for="(c, i) in form.CustomerTarget" :key="i">
                  <b-td>{{c.CustomerName ? c.CustomerName : (c.CustomerDesc ? c.CustomerDesc : c.CustomerCode)}}</b-td>
                  <b-td>{{c.TargetQuantity}}</b-td>
                  <b-td>{{c.TargetUnitLabel}}</b-td>
                  <b-td>{{c.ReqItem}}</b-td>
                  <b-td>{{c.ReqItemQuantity}}</b-td>
                  <b-td>{{c.DescriptionReqItem}}</b-td>
                  <b-td>{{c.GainAmount}}</b-td>
                  <b-td>{{c.CurrencyName}}</b-td>
                  <b-td class="text-center">
                    <b-button @click="editInvoiceLine(c)" class="btn mr-2 btn-warning btn-sm">
                      <i class="fa fa-pencil-alt"></i>
                    </b-button>
                    <b-button @click="removeContractItems(c)" class="btn mr-2 btn-danger btn-sm">
                      <i class="far fa-trash-alt"></i>
                    </b-button>
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-row>
        </b-tab>
        <b-tab :title="$t('insert.CustomerTarget.CustomerTargetDates')">
          <NextDetailPanel v-model="form.CustomerTargetDates" :items="customerTargetDatesItems"/>
        </b-tab>
      </b-tabs>
    </b-col>
  </b-row>
</template>
<script>
import insertMixin from '../../mixins/insert'
import { required, requiredIf } from 'vuelidate/lib/validators'
import { detailData } from './detailPanelData'
export default {
  mixins: [insertMixin],
  data () {
    return {
      form: {
        Delete: 0,
        System: 0,
        RecordState: 2,
        CustomerTargetDetails: [],
        CustomerTargetDates: [],
        CustomerTarget: [],
        Code: null,
        Description1: null,
        ErpCode: null,
        TciBreakId: null,
        ItemColumnName: null,
        ItemColumnValue: null,
        StatusId: 1
      },
      // customerTargetDetailsItems: detailData.customerTargetDetailsItems,
      customerTargetDatesItems: detailData.customerTargetDatesItems,
      routeName1: 'Customer',
      currencies: [],
      itemCriteria: null,
      itemColumnValue: null,
      itemColumnName: null,
      lookupValues: [],
      items: [],
      itemValue: [],
      fieldValues: [],
      itemCriterias: [],
      selectedIndex: null,
      customerTargetDetails: {
        customer: null,
        targetQuantity: null,
        targetUnit: null,
        reqItemQuantity: null,
        reqItem: null,
        descriptionReqItem: null,
        currency: null,
        gainAmount: null,
        isUpdated: false
      }
    }
  },
  mounted () {
    this.createManualCode()
    this.getItemCriterias()
    this.getCurrencies()
    this.getLookups()
    this.getItem()
  },
  methods: {
    getItemCriterias () {
      this.$api.postByUrl({paramId: 'ITEM_CRITERIA'}, 'VisionNextCommonApi/api/LookupValue/GetValuesBySysParams').then((response) => {
        if (response && response.Values && response.Values.length > 0) {
          this.itemCriterias = response.Values
        }
      })
    },
    successExcelImportCustomerTarget (data) {
      if (data) {
        let list = []
        Object.keys(data).map(d => {
          let obj = data[d]
          let existIndex = this.form.CustomerTarget.findIndex(c => c.CustomerId === obj.CustomerId)
          if (existIndex > -1) {
            this.form.CustomerTargetDetails.splice(existIndex, 1)
          }
          obj.RecordState = 2
          obj.StatusId = 1
          obj.Deleted = 0
          obj.System = 0
          obj.CurrencyId = 1
          obj.TargetUnitId = 501
          let unit = this.lookupValues.find(u => u.DecimalValue === obj.TargetUnitId)
          obj.TargetUnitLabel = unit ? unit.Label : (this.customerTargetDetails.targetUnit ? this.customerTargetDetails.targetUnit.Label : null)
          let currency = this.currencies.find(c => c.RecordId === obj.CurrencyId)
          obj.CurrencyName = currency ? currency.Description1 : null
          list.push(obj)
        })
        this.fillCustomerNames(list)
        this.form.CustomerTarget = [...list, ...this.form.CustomerTarget]
      }
    },
    fillCustomerNames (list) {
      let customerIds = list
        .map(c => c.CustomerId)
        .filter(id => id !== null && id !== undefined && id !== '')
        .map(id => Number(id))
      if (customerIds.length === 0) {
        return
      }
      let request = {
        andConditionModel: {
          RecordIds: customerIds
        }
      }
      this.$api.postByUrl(request, 'VisionNextCustomer/api/Customer/Search', customerIds.length).then((response) => {
        if (response && response.ListModel && response.ListModel.BaseModels) {
          let customerMap = {}
          response.ListModel.BaseModels.forEach(c => {
            customerMap[c.RecordId] = c.Description1 || c.Description2 || c.Code
          })
          list.forEach(item => {
            let name = customerMap[Number(item.CustomerId)]
            if (name) {
              this.$set(item, 'CustomerName', name)
              this.$set(item, 'CustomerDesc', name)
            }
          })
          this.$forceUpdate()
        }
      })
    },
    selectColumnName  (data) {
      this.fieldValues = []
      this.form.ItemColumnValue = null
      this.itemColumnValue = null
      if (data) {
        this.form.ItemColumnName = data.ForeignField
        this.$api.postByUrl({paramName: data.Label}, 'VisionNextCommonApi/api/LookupValue/GetSelectedParamNameByValues').then((res) => {
          this.fieldValues = res.Values
        })
      } else {
        this.form.ItemColumnName = null
      }
    },
    getLookups () {
      return this.$api.postByUrl({LookupTableCode: 'UNIT'}, 'VisionNextCommonApi/api/LookupValue/GetValuesMultiple?v=2').then((response) => {
        if (response && response.Values) {
          this.lookupValues = response.Values.UNIT
          this.customerTargetDetails.targetUnit = response.Values.UNIT[3]
          this.form.TargetUnitId = this.customerTargetDetails.targetUnit.RecordId
        }
      })
    },
    getCurrencies () {
      return this.$api.postByUrl({}, 'VisionNextSystem/api/SysCurrency/Search').then((response) => {
        if (response && response.ListModel && response.ListModel.BaseModels) {
          this.currencies = response.ListModel.BaseModels
          this.customerTargetDetails.currency = response.ListModel.BaseModels[0]
          this.form.CurrencyId = this.customerTargetDetails.currency.RecordId
        }
      })
    },
    getItem () {
      this.$api.postByUrl({andConditionModel: { StatusIds: [1] }}, '/VisionNextItem/api/Item/Search').then((response) => {
        if (response && response.ListModel && response.ListModel.BaseModels) {
          this.items = response.ListModel.BaseModels
          // this.form.ReqItemId = this.customerTargetDetails.reqItem.RecordId
        }
      })
    },
    addContractItems () {
      if (this.customerTargetDetails.reqItem && !this.customerTargetDetails.customer) {
        this.$toasted.show(this.$t('insert.customerRequired'), {
          type: 'error',
          keepOnHover: true,
          position: 'top-center',
          duration: '5000'
        })
        return
      }
      if (this.customerTargetDetails.reqItem && this.customerTargetDetails.customer && !this.customerTargetDetails.targetQuantity) {
        this.$toasted.show(this.$t('insert.targetQuantityRequired'), {
          type: 'error',
          keepOnHover: true,
          position: 'top-center',
          duration: '5000'
        })
        return
      }
      if (this.customerTargetDetails.reqItem && this.customerTargetDetails.customer && this.customerTargetDetails.targetQuantity && !this.customerTargetDetails.gainAmount) {
        this.$toasted.show(this.$t('insert.gainAmountRequired'), {
          type: 'error',
          keepOnHover: true,
          position: 'top-center',
          duration: '5000'
        })
        return
      }
      if (this.customerTargetDetails.reqItem && this.customerTargetDetails.customer && this.customerTargetDetails.targetQuantity && this.customerTargetDetails.gainAmount && !this.customerTargetDetails.reqItemQuantity) {
        this.$toasted.show(this.$t('insert.reqItemQuantityRequired'), {
          type: 'error',
          keepOnHover: true,
          position: 'top-center',
          duration: '5000'
        })
        return
      }
      // if (this.customerTargetDetails.reqItem && this.customerTargetDetails.customer && this.customerTargetDetails.targetQuantity && this.customerTargetDetails.gainAmount && this.customerTargetDetails.reqItemQuantity) {
      //   this.$toasted.show(this.$t('insert.descriptionReqItemRequired'), {
      //     type: 'error',
      //     keepOnHover: true,
      //     position: 'top-center',
      //     duration: '5000'
      //   })
      //   return
      // }
      this.$v.customerTargetDetails.$touch()
      if (this.$v.customerTargetDetails.$error) {
        this.$toasted.show(this.$t('insert.requiredFields'), { type: 'error', keepOnHover: true, duration: '3000' })
        return false
      }
      let filteredArr = this.form.CustomerTargetDetails.filter(i => i.CustomerId === this.customerTargetDetails.customer.RecordId && i.RecordState !== 4)
      if (filteredArr.length > 0) {
        this.$store.commit('showAlert', { type: 'danger', msg: this.$t('insert.sameRecordError') })
        return false
      }
      let item = {
        Deleted: 0,
        System: 0,
        RecordId: this.customerTargetDetails.recordId,
        RecordState: this.customerTargetDetails.recordId > 0 ? 3 : 2,
        StatusId: 1,
        CustomerId: this.customerTargetDetails.customer.RecordId,
        CustomerName: this.customerTargetDetails.customer.Description1,
        TargetUnitId: this.customerTargetDetails.targetUnit.DecimalValue,
        TargetUnitLabel: this.customerTargetDetails.targetUnit.Label,
        ReqItemId: this.customerTargetDetails.reqItem ? this.customerTargetDetails.reqItem.RecordId : null,
        ReqItem: this.customerTargetDetails.reqItem ? this.customerTargetDetails.reqItem.Description1 : null,
        TargetQuantity: this.customerTargetDetails.targetQuantity,
        ReqItemQuantity: this.customerTargetDetails.reqItemQuantity,
        DescriptionReqItem: this.customerTargetDetails.descriptionReqItem,
        GainAmount: this.customerTargetDetails.gainAmount,
        CurrencyId: this.customerTargetDetails.currency.RecordId,
        CurrencyName: this.customerTargetDetails.currency.Description1
      }
      if (this.customerTargetDetails.isUpdated) {
        this.form.CustomerTarget[this.selectedIndex] = item
        this.selectedIndex = null
      } else {
        this.form.CustomerTarget.push(item)
      }
      this.customerTargetDetails = {}
      this.$v.customerTargetDetails.$reset()
      this.getCurrencies()
      this.getLookups()
    },
    removeContractItems (item) {
      if (item.RecordId > 0) {
        this.form.CustomerTarget[this.form.CustomerTarget.indexOf(item)].RecordState = 4
      } else {
        this.form.CustomerTarget.splice(this.form.CustomerTarget.indexOf(item), 1)
      }
    },
    editInvoiceLine (item) {
      this.customerTargetDetails = item
      this.customerTargetDetails.isUpdated = true
      this.selectedIndex = this.form.CustomerTarget.indexOf(item)
      this.customerTargetDetails = {
        targetQuantity: item.TargetQuantity,
        reqItemQuantity: item.ReqItemQuantity,
        descriptionReqItem: item.DescriptionReqItem,
        gainAmount: item.GainAmount,
        isUpdated: true
      }
      this.getCurrencies(item.CurrencyId)
      this.getLookups(item.TargetUnitId)
      this.getItem(item.ReqItemId)
    },
    save () {
      this.$v.form.$touch()
      if (this.$v.form.$error) {
        this.$store.commit('showAlert', { type: 'danger', msg: this.$t('insert.requiredFields') })
      } else {
        this.form.CustomerTargetDetails = this.form.CustomerTarget.map((item) => {
          let creditBudgetDetail = {
            TargetUnitId: item.TargetUnitId,
            TargetQuantity: item.TargetQuantity,
            ReqItemId: item.ReqItemId,
            ReqItemQuantity: item.ReqItemQuantity,
            CurrencyId: item.CurrencyId,
            DescriptionReqItem: item.DescriptionReqItem,
            GainAmount: item.GainAmount,
            CustomerId: item.CustomerId,
            RecordState: 2,
            StatusId: 1,
            Deleted: 0,
            System: 0,
            CustomerTarget: item
          }

          return creditBudgetDetail
        })
        this.createData()
      }
    }
  },
  validations () {
    let customerTargetDetails = {
      currency: {
        required
      },
      reqItem: {
        required: requiredIf(function () {
          return !(customerTargetDetails.customer && customerTargetDetails.targetQuantity && customerTargetDetails.gainAmount) ? required : !required
        })
      },
      customer: {
        required
      },
      targetQuantity: {
        required
      },
      reqItemQuantity: {
        required: requiredIf(function () {
          return !(customerTargetDetails.customer && customerTargetDetails.targetQuantity && customerTargetDetails.gainAmount) ? required : !required
        })
      },
      // descriptionReqItem: {
      //   required: requiredIf(function () {
      //     return !required
      //   })
      // },
      gainAmount: {
        required
      }
    }
    return {
      form: this.insertRules,
      customerTargetDetails: customerTargetDetails
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/CustomerTarget/insert.vue